import * as React from "react";
import { Styled, Header as HeaderBase, useColorMode } from "theme-ui";
import styled from "@emotion/styled";
import useSiteMetadata from "gatsby-theme-gallery/src/hooks/useSiteMetadata";
import { Link } from "gatsby"

const Button = styled.button<{ theme?: any }>`
  padding: 0.4rem 0.75rem;
  font-size: 0.875rem;
  cursor: pointer;
  background: none;
  border: 1px solid ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.primary};
`;

const Header = () => {
  const siteMetadata = useSiteMetadata();
  const [colorMode, setColorMode] = useColorMode();

  return (
    <HeaderBase>
      <Link style={{ textDecoration: "none" }} to="/">
        <Styled.h1>{siteMetadata.title}</Styled.h1>
      </Link>


      <div>
          <nav>
            <ul style={{ display: "flex", flex: 1 }}>
              {siteMetadata.menuLinks.map(link => (
                <li
                  key={link.name}
                  style={{
                    listStyleType: `none`,
                    padding: `1rem`,
                  }}
                >
                  <Link style={{textDecoration: "none" }} to={link.link}>
                    <Styled.a>{link.name}</Styled.a>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

      <Button
        onClick={() => {
          setColorMode(colorMode === "light" ? "dark" : "light");
        }}
      >
        Villany {colorMode === "light" ? "le" : "fel"}
      </Button>
    </HeaderBase>
  );
};

export default Header;
